import { useDropzone } from 'react-dropzone';
import Iconify from '../Iconify';
import RejectionFiles from './RejectionFiles';
import MultiPreviewNamesList from './MultiPreviewNamesList';

// ----------------------------------------------------------------------

export default function UploadContatos({ error, files, onRemove, showPreview, helperText, sx, ...other }) {
  const { getRootProps, getInputProps, isDragActive, isDragReject, fileRejections } = useDropzone({
    multiple: false,
    ...other,
  });

  return (
    <>
      <div
        className={`w-full h-[140px] mx-auto p-2 border border-dashed rounded-lg transition-colors
          ${isDragReject || error
            ? 'border-red-400 dark:border-red-500'
            : 'border-gray-300 dark:border-[#383838]'
          }
          ${isDragActive ? 'border-[#7C3AED] bg-violet-50/50 dark:bg-violet-500/5' : 'bg-white dark:bg-[#222529]'}
        `}
      >
        <div
          {...getRootProps()}
          className={`z-0 w-full h-full outline-none flex overflow-hidden relative items-center justify-center cursor-pointer rounded-md
            ${isDragActive ? 'opacity-72' : ''}
          `}
        >
          <input {...getInputProps()} />

          <div className="flex absolute items-center flex-col justify-center text-gray-500 dark:text-[#ABABAD] bg-gray-50 dark:bg-[#1A1D21] w-full h-full rounded-md transition-opacity hover:opacity-70">
            <Iconify icon="material-symbols:csv" className="w-6 h-6 mb-1 text-gray-400 dark:text-[#ABABAD]" />
            <span className="text-xs font-medium text-gray-500 dark:text-[#ABABAD]">Inserir CSV</span>
          </div>
        </div>
      </div>

      {helperText && helperText}

      <MultiPreviewNamesList files={files} showPreview={showPreview} onRemove={onRemove} onRemoveAll={() => {}} />

      {fileRejections.length > 0 && <RejectionFiles fileRejections={fileRejections} />}
    </>
  );
}
